import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { SpecificRoute as SpecificRouteModel } from 'models/specificRoute';
import { getFormattedPrice } from 'utils/currency';

import { PreviewContainer, Item, ValuesContainer, Point } from './styles';

interface Props {
  values: SpecificRouteModel[];
  countryCurrency: string;
}

interface PreviewItems {
  title?: string;
  maxDays?: number;
  price?: number;
  flexibility?: number;
}

const PreviewItems = ({ values, countryCurrency }: Props) => {
  const { t } = useStoreTranslation();
  const formattedPrice = (value: number | undefined) => {
    const { formatted } = getFormattedPrice({ value, currency: countryCurrency, t });
    return formatted;
  };

  return (
    <PreviewContainer>
      {values.slice(0, 3).map((value) => (
        <Item key={`${value.departurePointCode}-${value.arrivalPointCode}`}>
          <Item.Title>{`${value.departurePoint} - ${value.arrivalPoint}`}</Item.Title>
          <ValuesContainer>
            <Item.Value>
              {value.specificFlightAnticipationDays && value.specificFlightAnticipationDays > 0
                ? `${value.specificFlightAnticipationDays}
                  ${t('rule.restriction.anticipationSuffix')}`
                : t('rule.restriction.withoutRestriction')}
            </Item.Value>
            <Point> • </Point>
            <Item.Value>
              {value.maxPrice ? formattedPrice(value.maxPrice) : t('rule.restriction.withoutRestriction')}
            </Item.Value>
            <Point> • </Point>
            <Item.Value>
              {value.specificFlightFlexibility
                ? `${value.specificFlightFlexibility}%`
                : t('rule.restriction.withoutRestriction')}
            </Item.Value>
          </ValuesContainer>
        </Item>
      ))}
    </PreviewContainer>
  );
};

export default PreviewItems;
